/**
 * @generated SignedSource<<f27e2bce6e2993ba5f3436feb9829f9b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactBuyerForm_transaction$data = {
  readonly buyer: {
    readonly serviceId: string | null;
  } | null;
  readonly item: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "ContactBuyerForm_transaction";
};
export type ContactBuyerForm_transaction$key = {
  readonly " $data"?: ContactBuyerForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactBuyerForm_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactBuyerForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "buyer",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "7f1a5670e64c11e82f2d9e249fac72b1";

export default node;
